// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchOnboardingOverhaul-cls1_TH1","cls2":"SearchOnboardingOverhaul-cls2_ouf SearchOnboardingOverhaul-cls1_TH1"};